export default class GoogleGeoAddress {

    constructor(addresses) {
        if(addresses.length > 1){
            //exclude google address error Potulicka 20D, 70-234 Szczecin
            addresses = addresses.filter(a => a.place_id !== 'ChIJ61mAtTIPqkcRzOj_UObj3-I');
        }
        this.$address = addresses[0];
    }

    street() {
        return this.$findLongName('route');
    }

    buildingNumber() {
        return this.$findLongName('street_number');
    }

    zip() {
        return this.$findLongName('postal_code', 'postal_code_prefix');
    }

    city() {
        return this.$findLongName('locality');
    }

    location() {
        return this.$address.geometry.location;
    }

    lat() {
        return this.location().lat();
    }

    lng() {
        return this.location().lng();
    }

    toObject() {
        return {
            street: this.street(),
            building_number: this.buildingNumber(),
            zip: this.zip(),
            city: this.city(),
            geo: {
                lat: this.lat(),
                lng: this.lng(),
            },
        };
    }

    $findLongName(includes, doesntInclude = null) {
        const piece = this.$findComponent(includes, doesntInclude);

        if (piece) {
            return piece.long_name;
        }

        return null;
    }

    $findComponent(includes, doesntInclude = null) {
        return this.$address.address_components.find((item) => {
            const hasIncludes = item.types.includes(includes);

            if (doesntInclude) {
                return hasIncludes && !item.types.includes(doesntInclude);
            }

            return hasIncludes;
        });
    }

}
